module.exports = __webpack_public_path__ + "static/media/emailSuccess.3c1d226c.svg";